import React, { Children, HTMLAttributes } from 'react';
import { DropdownBaseItem, IDropdownItemBaseProps } from './DropdownBaseItem';
import { useTestId } from '../../hooks/useTestId/useTestId';
import { DropdownParentItem } from './DropdownParentItem';

export interface IDropdownItemAsButtonProps
  extends Omit<IDropdownItemBaseProps, 'isTitle' | 'onClick' | 'asContainer'>,
    React.PropsWithChildren<HTMLAttributes<HTMLButtonElement>> {
  inlineNesting?: boolean;
}

export const DropdownItem = React.forwardRef<HTMLButtonElement, IDropdownItemAsButtonProps>((args, ref) => {
  const { generateTestId } = useTestId(args, 'DropdownItem');
  const hasItems = Children.count(args.children) > 0 && typeof args.children !== 'string';

  return hasItems ? (
    <DropdownParentItem ref={ref} {...args} />
  ) : (
    <DropdownBaseItem {...generateTestId()} ref={ref} {...args} postTrailingIcon={args.compact ? undefined : args.postTrailingIcon} />
  );
});

interface IDropdownItemTitleProps extends React.PropsWithChildren, Omit<IDropdownItemBaseProps, 'isTitle' | 'asContainer'> {}

export const DropdownItemTitle = React.forwardRef<HTMLParagraphElement, IDropdownItemTitleProps>(({ ...rest }, ref) => (
  <DropdownBaseItem ref={ref} key={rest.key ?? rest.label} {...rest} isTitle />
));

interface IDropdownItemContainerProps extends React.PropsWithChildren, Omit<IDropdownItemBaseProps, 'asContainer' | 'isTitle'> {}

export const DropdownItemContainer = React.forwardRef<HTMLDivElement, IDropdownItemContainerProps>(({ ...rest }, ref) => (
  <DropdownBaseItem ref={ref} key={rest.key ?? rest.label} {...rest} asContainer />
));
